import CartItem from './CartItem'
import { useGlobalContext } from '../context'
import {useRef, useState} from 'react'


const Navbar = () => {
    const { searchPlayers,clearItems, total, dropdown,checkout, checkOut } = useGlobalContext();
    const inputEl = useRef(null);
    const [show, setShow] = useState(false)
    return (
        <nav className={`${checkout ? 'hidden' : 'navbar fixed-top navbar-expand-lg sticky  bg-dark'}`}>
            <div className="navbar-collapse">
                <img style={{cursor:'pointer'}} onClick={() => window.location.reload()} className='navbar-brand' src="..\img\logo.svg" alt="xx"/>
                <h2 className="navbar-text nav-item m-auto">Build Your Team!</h2>
                <form className="form-inline my-2 my-lg-0 search">
                    <input className="form-control mr-sm-2 " ref={inputEl} onChange={e => { inputEl.current.value = (e.target.value); searchPlayers(inputEl.current.value) }} type="search" placeholder="Search Players" value={`${inputEl.current ? inputEl.current.value : ''}`} aria-label="Search" />
                    <i className="fas fa-search  rounded" style={{pointerEvents: 'none'}}></i>
                </form>
                <button className='rules-btn' onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>Rules</button>
                <div className={`rules ${show ? '' : 'hidden'}`}>
                    <ul className="list-group">
                        <li className="list-group-item">1.You must have 5 players on your team.</li>
                        <li className="list-group-item">2.You can't exceed the budget of &nbsp; 16$</li>
                        <li className="list-group-item">2.No duplicate players</li>
                        <li className="list-group-item">3.Think of every player as in their primes</li>
                    </ul>
                </div>
                <div className="nav-item dropdown  d-lg-flex ml-auto">
                    <div id="cart-info" className="nav-info  align-items-center d-flex justify-content-between mx-lg-5 rounded-pill border border-white">
                        <a href="/#" className="nav-link cart-link p-0 ml-3" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            <span className="cart-info__icon mr-lg-1"><i className="fas fa-shopping-cart"></i></span>
                        </a>
                        <p className="mb-0 text-capitalize p-2 pr-3"><span id="player-count">{dropdown.length} </span> Players - $<span className="item-total">{total}</span></p>
                        <div className="dropdown-menu mt-3  p-2 bg-dark " aria-labelledby="navbarDropdown">
                            <form id="form" >
                                <div className=" container-fluid dropdown-item bg-dark">
                                    <div className="row max-height justify-content-end ">
                                        <div id="cart" className="show-cart bg-dark rounded">
                                            <CartItem></CartItem>
                                            <div className="cart-total-container d-flex justify-content-around text-capitalize bg-dark rounded p-2 mt-4 border border-light">
                                                <h4>total amount :</h4>
                                                <h4> $ <strong id="cart-total" className="font-weight-bold">{total}</strong> </h4>
                                            </div>
                                            <div className="cart-buttons-container mt-3 d-flex justify-content-between">
                                                <a href='/#' onClick={clearItems} id="clear-cart" className="btn btn-outline-secondary btn-black text-uppercase rounded-pill ">clear cart</a>
                                                <p>&nbsp;&nbsp;</p>
                                                <a href='/#' onClick={checkOut}id="checkout" className="btn btn-outline-secondary text-uppercase rounded-pill ">checkout</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar